/**
 * Styled Components - Created by cazarez on 12/02/18.
 */
import styled from 'styled-components'

interface StyledProps {
  flexWrap?: string
  fromDetails?: boolean
  justifyContent?: string
  fontSizeMobile?: string
  noMargin?: boolean
  secondary?: boolean
}

export const Container = styled.div`
  display: flex;
  flex-wrap: ${({ flexWrap }: StyledProps) => flexWrap || 'unset'};
  margin: ${({ noMargin }: StyledProps) => !noMargin ? '20px 0' : '0'};
  @media (max-width: 885px) {
    ${({ noMargin, secondary }: StyledProps) => noMargin ? `
      margin-top: ${secondary ? '8px' : '22px'};
      margin-bottom: -12px;
    ` : ''}
  }
  @media (max-width: 768px) {
    justify-content: ${({ justifyContent }: StyledProps) => justifyContent || 'unset'};
    margin: ${({ fromDetails }: StyledProps) => fromDetails ? '14px 0' : '20px 0'};
  }
`

export const Text = styled.div`
  margin-left: 20px;
  height: 23px;
  width: 100.29px;
  color: #5f6062;
  font-size: 16px;
  line-height: 23px;

  @media (max-width: 768px) {
    font-size: ${({ fontSizeMobile }: StyledProps) => fontSizeMobile || '16px'};
  }
`

export const StyledImg = styled.img``

export const StyledStars = styled.div`
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/Ratings/styledComponents.tsx